export async function stringifyCSV({
  fileName,
  inputArray,
}: {
  fileName: string;
  inputArray: unknown[];
}) {
  const libStringifyCSV = (
    await import(
      /* webpackPrefetch: true, webpackChunkName: "csv-stringify" */ 'csv-stringify/lib/sync'
    )
  ).default;

  return libStringifyCSV(
    typeof inputArray[0] === 'object'
      ? [
          // The first entry determines what columns exist in the CSV, so it needs to have all possible fields
          {
            ...Object.fromEntries(
              inputArray.flatMap((x) =>
                x ? Object.keys(x).map((key) => [key, undefined]) : [],
              ),
            ),
            ...inputArray[0],
          },
          ...inputArray.slice(1),
        ]
      : inputArray.map((item) => ({ [fileName]: item })),
    {
      header: true,
    },
  );
}
